<template>
    <div class="contract-detail-page">
        <Breadcrumb />
        <contract-detail-comp :class="{'fixed': listIsFixed}"></contract-detail-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import contractDetailComp from '@/components/landlord/leaseManagement/contractDetail/contractDetailComp.vue'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('contract-detail-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('contract-detail-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        Breadcrumb,
        contractDetailComp
    }
}
</script>
<style lang="scss" scoped>
    .contract-detail-page{
        position: relative;
        margin-top: 82px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/ContractDetail.vue